import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "platform-admin-dashboard" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Visão geral"),
  /*#__PURE__*/_createElementVNode("p", null, "Métricas agregadas de todos os tenants do Fluxoo DOC.")
], -1)
const _hoisted_3 = { class: "tiles" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Tenants", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Contas ativas no sistema.", -1)
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", null, "Usuários", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Usuários cadastrados em todos os tenants.", -1)
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", null, "Documentos", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "Documentos criados em todos os tenants.", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", null, " ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "•••", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", null, " ", -1)
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "tenants-breakdown" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h1", null, "Tenants", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "tenants-title doc-grid" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Nome")
  ]),
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Usuários")
  ]),
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Documentos")
  ]),
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Módulos ativos")
  ]),
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Ações")
  ])
], -1)
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "actions" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11.89 5.05078C12.0996 6.39164 12.7486 7.62492 13.735 8.55703C14.7214 9.48914 15.9894 10.0673 17.34 10.2008M3 22.0008H21",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_26 = [
  _hoisted_25
]

import { onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import { TenantModel } from '@/models/TenantModel'
import { TenantModuleEnum, tenantModuleLabels } from '@/enums/Tenants/TenantModuleEnum'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'

interface TenantWithCounts extends TenantModel {
  users_count: number
  documents_count: number
}

interface DashboardResponse {
  totals: { tenants: number, users: number, documents: number }
  tenants: TenantWithCounts[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformAdminDashboardView',
  setup(__props) {

const axios = useAxios()
const totals = ref<DashboardResponse['totals']>()
const tenants = ref<TenantWithCounts[]>()

onMounted(() => {
  axios.get('/api/platform-admin/dashboard').then((res: AxiosResponse<DashboardResponse>) => {
    totals.value = res.data.totals
    tenants.value = res.data.tenants
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (totals.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", null, _toDisplayString(totals.value.tenants), 1),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("p", null, _toDisplayString(totals.value.users), 1),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("p", null, _toDisplayString(totals.value.documents), 1),
              _hoisted_12
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(3, (n) => {
            return _createElementVNode("div", {
              class: "item skeleton",
              key: n
            }, _hoisted_16)
          }), 64))
    ]),
    _createElementVNode("section", _hoisted_17, [
      _hoisted_18,
      _hoisted_19,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenants.value, (tenant) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "tenants-list doc-grid",
          key: tenant.id
        }, [
          _createElementVNode("label", _hoisted_20, [
            _createElementVNode("h1", null, _toDisplayString(tenant.name), 1),
            _createElementVNode("h2", null, _toDisplayString(tenant.acronym), 1)
          ]),
          _createElementVNode("label", null, [
            _createElementVNode("h1", null, _toDisplayString(tenant.users_count), 1)
          ]),
          _createElementVNode("label", null, [
            _createElementVNode("h1", null, _toDisplayString(tenant.documents_count), 1)
          ]),
          _createElementVNode("label", null, [
            (tenant.modules?.length)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_21, _toDisplayString(tenant.modules.map((m) => _unref(tenantModuleLabels)[m as TenantModuleEnum] ?? m).join(', ')), 1))
              : (_openBlock(), _createElementBlock("h1", _hoisted_22, "Nenhum"))
          ]),
          _createElementVNode("label", _hoisted_23, [
            _createElementVNode("button", {
              class: "tooltip",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'platform-admin.tenants.edit', params: { id: tenant.id } }))
            }, _hoisted_26, 8, _hoisted_24)
          ])
        ]))
      }), 128)),
      (!tenants.value)
        ? (_openBlock(), _createBlock(SpinnerLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})